import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("[ErrorBoundary]", error, info?.componentStack);
    }
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
    // Force a soft re-render to root; if errors persist user can navigate home.
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFF8EE] px-6">
        <div className="max-w-md text-center" data-testid="error-boundary">
          <div className="text-[10px] uppercase tracking-[0.22em] text-[#064E3B]">TREL</div>
          <h1 className="font-serif text-3xl mt-3">Something went off-script</h1>
          <p className="text-sm text-[#071A2D]/70 mt-3">
            We hit an unexpected issue rendering this page. Your data is safe.
          </p>
          {process.env.NODE_ENV !== "production" && this.state.error && (
            <pre className="text-[11px] text-left mt-4 p-3 rounded-2xl bg-white border border-[#071A2D]/10 overflow-auto max-h-40">
              {String(this.state.error?.message || this.state.error)}
            </pre>
          )}
          <div className="mt-6 flex gap-3 justify-center">
            <button onClick={this.reset} className="btn-outline-emerald">Try again</button>
            <a href="/" className="btn-coral">Go home</a>
          </div>
        </div>
      </div>
    );
  }
}
